var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-evolution-loyer"},[(_vm.chart_evolution_loyers.title)?_c('p',{staticClass:"label main_color_text",class:{'--medium': _vm.dense}},[_vm._v("\n    "+_vm._s(typeof _vm.chart_evolution_loyers.title == "string"
        ? _vm.chart_evolution_loyers.title
        : _vm.chart_evolution_loyers.title.value
        ? _vm.chart_evolution_loyers.title.value
        : "")+"\n  ")]):_vm._e(),_c('el-line-chart',{key:_vm.evolution_loyer_chart_key,attrs:{"name":"evolution_loyers","values":_vm.data_chart,"height":162}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }